import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiX } from 'react-icons/hi';
import TextInput from '@components/forms/TextInput';
import Button from '@components/ui/Button';
import AlertBox from '@components/ui/AlertBox';
import axiosInstance from '@libs/axiosInstance';
import { toast } from 'sonner';
import { useNavigate } from 'react-router';

const CourseQuizModal = ({ isOpen, onClose, courseId, courseTitle}) => {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [submitError, setSubmitError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      reset({ number_of_questions: '', duration: '' });
      setSubmitError(null);
    }
  }, [isOpen, reset]);

  const onSubmit = async (data) => {
    setSubmitError(null);
    try {
      console.log('Quiz data:', { ...data, courseId });
      let response = await axiosInstance.post('/question_bank/create-course-quiz/', {
        ...data, 
        course: courseId,
        expected_duration: data.expected_duration ? `${data.expected_duration}:00` : null,
      })
      let quiz_id = response.data.id;
      toast.success(`Quiz for "${courseTitle}" created`);

      navigate(`/quizzes/${quiz_id}/view`)
      onClose();
    } catch (error) {
      console.log(error)
      setSubmitError(error?.response?.data?.message || 'Failed to create quiz. Please try again.');
    }
  };

  return (
    <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box max-w-2xl">
        <label className="absolute right-4 top-4">
          <HiX className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </label>

        {/* Highlight Topics */}
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 my-4 max-h-40 overflow-y-auto">
          <h3 className="text-purple-700 font-semibold text-sm mb-2">Create Quiz for Course:</h3>
          <span className='text-lg'> {courseTitle || 'Course'}</span>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {submitError && <AlertBox message={submitError} type="error" />}

            <TextInput
              label="Number of Questions"
              name="number_of_questions"
              type="number"
              min="2"
              placeholder="e.g., 10"
              register={register}
              errors={errors}
              validationRules={{
                required: 'Number of questions is required',
                min: { value: 2, message: 'Must be at least 2' }
              }}
            />

            <TextInput
              label="Duration (minutes)"
              name="expected_duration"
              type="number"
              placeholder="e.g., 30"
              register={register}
              errors={errors}
              validationRules={{
                required: 'Duration is required',
                min: { value: 1, message: 'Duration must be positive' }
              }}
            />

          <div className="modal-action">
            <Button isLoading={isSubmitting}>Create Quiz</Button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}>
        <button className="">Close</button>
      </div>
    </div>
  );
};

export default CourseQuizModal;
